import APIClient from '@/shared/http/clients/api'

const resourceName = 'usuario-fila'
const APICore = process.env.APIBaseURLCore

const GetAll = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetAllActive = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?inative=0&sort=nome,asc&size=500`, data, config)
const Create = (data) => APIClient.post(`${APICore}/${resourceName}/`, data)
const Update = (data, id) => APIClient.put(`${APICore}/${resourceName}/${id}`, data)
const GetById = (id) => APIClient.get(`${APICore}/${resourceName}/${id}`)
const GetLoggedFila = (config = {}) => APIClient.get(`${APICore}/${resourceName}/logged-fila`, config)
const GetByTipo = (tipo, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/tipo?tipo=${tipo}&page=${index}&size=${limit}`, config)

const UserRepository = {
  GetAll,
  GetAllActive,
  Create,
  Update,
  GetById,
  GetLoggedFila,
  GetByTipo
}

export default UserRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/nxSenhas/usuario.js